import * as R from 'ramda';

/*
  MONIT board data. Two endpoints by design (see MONIT_API_DESIGN.md):

    retrievePatients  first load only — slow-changing identity/programme/device data
    retrieveStatus    the poll loop  — only what changes between ticks

  They are merged in the container by `epId`, which is why neither response repeats the
  other's fields (room/bed live only in retrievePatients; state/battery only in
  retrieveStatus).
*/

const retrievePatients = {
  fe2be: R.identity,
  be2fe: ({ value: { patients = [] } = {} } = {}) => ({ patients }),
};

const retrieveStatus = {
  fe2be: R.identity,
  be2fe: ({ value: { devices = [], etag = null } = {} } = {}) => ({ devices, etag }),
};

/* Closes the alert standing against one card. `isContinuous` is not optional — the controller
   branches on it to pick closeContinuousAlert over closeAlert, and MONIT is continuous-only. */
const closeAlert = {
  fe2be: ({ alertId }) => ({ id: alertId, isContinuous: true }),
  be2fe: ({ value } = {}) => ({ alert: value || null }),
};

/* Creates a note against the alert standing on a card.

   `closeAlert` is deliberately always false. The backend closes the alert BEFORE it writes the
   note (NoteService.create), and closeContinuousAlert throws once an alert is already closed —
   so asking for both in one call means a pad changed mid-dialog loses the carer's typed note.
   The card sends the note on its own and closes separately. */
const createNote = {
  fe2be: ({ alertId, content, category, startTime, endTime }) => ({
    relatedId: alertId,
    type: 'ALERT',
    isContinuous: true,
    closeAlert: false,
    content,
    category,
    issued: new Date(),
    startTime,
    endTime,
  }),
  be2fe: ({ value } = {}) => ({ note: value || null }),
};

export default {
  retrievePatients,
  retrieveStatus,
  closeAlert,
  createNote,
};
